import client from './api-client';

export const getCargasPrevias = async(query) => {
    try {
        
        const response = await client.get(`ingreso-caso/carga-masiva?q=${query}`);
       
        if (response.status === 200 && response.data.code === 1) {
            return {
                cargas_previas: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

export const postCargarArchivo = async(file) => {
    try {
        
        const response = await client.post('ingreso-caso/carga-archivo', file);
        
        if (response.status === 200 && response.data.code === 1) {
            return response.data.object;
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const serviceGetProveedores = async (query) => {
    try {
        const response = await client.get(`proveedores-rol?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}